import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { get } from 'lodash';

import { GET_ROLES } from '../../../graphql/queries/roles';
import { GET_USERS } from '../../../graphql/queries/user';

export function Roles() {
  const [roles, setRoles] = useState([]);
  const { loading: rolesLoading, data: roleData } = useQuery(GET_ROLES, {
    onCompleted: (response) => setRoles(get(response, 'roles', [])),
  });
  const { loading: usersLoading, data: usersData } = useQuery(GET_USERS, {
    onCompleted: (response) => setRoles(get(response, 'roles', [])),
  });

  useEffect(() => {
    if (!rolesLoading && !usersLoading) {
      const filteredRoles = roleData.roles.filter((role) =>
        usersData.users.edges.some((user) => user?.node?.userRole.id === role.id)
      );
      const mappedRoles = filteredRoles.map((role) => ({
        ...role,
        usersCount: usersData?.users?.edges?.filter(
          (user) => user?.node?.userRole.id === role.id
        )?.length,
      }));
      setRoles(mappedRoles);
    }
  }, [usersData, roleData, rolesLoading, usersLoading]);

  return <Outlet context={{ roles, rolesLoading: rolesLoading || usersLoading }} />;
}
